import { client } from '../client';
import { PaymentProfile } from './types/PaymentProfile';

export const addPaymentProfile = async (payload: PaymentProfile): Promise<PaymentProfile> => {
  const { data } = await client.post(`/payment_profiles`, payload);

  return data;
};
